export enum MeasureUnit {
  inch = 'inch',
  meter = 'm',
  centimeter = 'cm',
  yard = 'yd',
}
